var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7667 0.405333C10.4012 0.142227 9.95678 0 9.5 0C9.04322 0 8.59876 0.142227 8.23333 0.405333L0.844444 5.72533C0.582253 5.91411 0.369446 6.1589 0.222876 6.44031C0.0763063 6.72173 0 7.03204 0 7.34667V16.9733C0 17.5108 0.22242 18.0263 0.61833 18.4064C1.01424 18.7865 1.55121 19 2.11111 19H6.22778C6.53572 19 6.83106 18.8826 7.04881 18.6735C7.26656 18.4645 7.38889 18.181 7.38889 17.8853V12.92C7.38889 12.3825 7.61131 11.867 8.00722 11.4869C8.40313 11.1069 8.9401 10.8933 9.5 10.8933C10.0599 10.8933 10.5969 11.1069 10.9928 11.4869C11.3887 11.867 11.6111 12.3825 11.6111 12.92V17.8853C11.6111 18.181 11.7334 18.4645 11.9512 18.6735C12.1689 18.8826 12.4643 19 12.7722 19H16.8889C17.4488 19 17.9858 18.7865 18.3817 18.4064C18.7776 18.0263 19 17.5108 19 16.9733V7.34667C19 7.03204 18.9237 6.72173 18.7771 6.44031C18.6306 6.1589 18.4177 5.91411 18.1556 5.72533L10.7667 0.405333Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.42001d39b9463265e0b052a7bde366c2.svg";
export { ForwardRef as ReactComponent };